import React, { useEffect, useState, useRef } from 'react';
import { ButtonLoading, SimpleDialog, Icons, NewLoading } from 'components';
import { Grid, Button } from '@mui/material';
import { useStyles } from './Style';
import clsx from 'clsx';

export default function ExportButton({
  onExport,
  types = ['xls', 'csv'],
  loading,
  isExport = false,
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [isShowMenu, setIsShowMenu] = useState(null);
  const menuRef = useRef(null);
  const menuBtnRef = useRef(null);
  const classes = useStyles();
  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside, true);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside, true);
    };
  }, []);

  useEffect(() => {
    if (!loading) setAnchorEl(null);
  }, [loading]);

  const handleClickOutside = (e) => {
    if (
      menuRef.current &&
      !menuRef.current.contains(e.target) &&
      !menuBtnRef.current.contains(e.target)
    ) {
      setIsShowMenu(null);
    }
  };

  const handleShowDialog = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClick = (event, item) => {
    setIsShowMenu(event);

    if (item?.length === 1) {
      if (item[0].type && onExport) {
        onExport(item[0].type, 0);
      }
    }
  };

  const handleClose = (type, index) => {
    setIsShowMenu(null);
    if (type && onExport) {
      onExport(type, index);
    }
  };
  return (
    <>
      <Grid direction="column" className={classes.reciveBtnMain}>
        <>
          <ButtonLoading
            variant="contained"
            onClick={handleShowDialog}
            startIcon={<Icons icon="ReceiveSquare" color="#fff" size="23" />}
            color="primary"
            name={'دریافت فایل خروجی'}
            aria-controls="simple-menu"

            aria-haspopup="true"
            className={classes.reciveBtn}
          />

          <SimpleDialog
            fullWidth
            maxWidth="sm"
            customClass={classes.customClassdialogContent}
            open={anchorEl}
            icon={<Icons icon="OpenNewTab" color="#303DBF" size="20" />}
            title={'دریافت فایل خروجی'}
            onClose={() => setAnchorEl(null)}
            style={{ padding: '30px' }}
          >
            <Grid container alignItems="center">
              <div className={classes.mainContent}>
                <p className={classes.description}>
                  کاربر گرامی جهت انتخاب نوع فایل خروجی، یکی از موارد زیر را انتخاب کنید:
                </p>
                {!isExport ? (
                  <Grid item justifyContent={'space-between'} className={classes.gridColumn}>
                    {types?.length !== 0 && (
                      <>
                        {types.map((v, k) => (
                          <div key={k} className={classes.box}>
                            <Button
                              className={classes.blockReport}
                              onClick={() => handleClose(v, k)}
                            >
                              {!isExport && (
                                <>
                                  {/* این کد به دلیل عدم نمایش تصویر پس از باندل به این شکل نوشته شده است */}
                                  {v.toLowerCase() == 'pdf' && (
                                    <img
                                      alt="icon download"
                                      className={classes.icons}
                                      src="./images/pdf.svg"
                                    />
                                  )}

                                  {v.toLowerCase() == 'csv' && (
                                    <img
                                      alt="icon download"
                                      className={classes.icons}
                                      src="./images/csv.svg"
                                    />
                                  )}

                                  {v.toLowerCase() == 'xls' && (
                                    <img
                                      alt="icon download"
                                      className={classes.icons}
                                      src="./images/xls.svg"
                                    />
                                  )}
                                </>
                              )}

                              <span>{v} </span>
                            </Button>
                          </div>
                        ))}
                      </>
                    )}

                    {loading && (
                      <div className={classes.loadingContent}>
                        <NewLoading />
                      </div>
                    )}
                  </Grid>
                ) : (
                  <Grid
                    item
                    justifyContent={'space-between'}
                    className={classes.gridColumn}
                    ref={menuBtnRef}
                  >
                    <div className={classes.box}>
                      <Button
                        className={clsx(
                          classes.blockReport,
                          Boolean(isShowMenu === 'xls') ? 'isopen' : '',
                        )}
                        ref={menuRef}
                        onClick={() => handleClick('xls', [])}
                      >
                        <img
                          alt="icon download"
                          className={classes.icons}
                          src={'./images/xls.svg'}
                        />
                        <span>xls </span>

                        <b className={classes.arrowList}>
                          <Icons icon="CaretDown" color="#303DBF" size="23" />
                        </b>
                      </Button>

                      <div
                        className={classes.menu}
                        style={{
                          opacity: !Boolean(isShowMenu === 'xls') ? '0' : '1',
                          visibility: !Boolean(isShowMenu === 'xls') ? 'hidden' : 'visible',
                        }}
                      >
                        <ul>
                          {types.map((v, k) => (
                            <li className={classes.menuItem} onClick={() => handleClose(v, k)}>
                              <Icons icon="ReceiveSquare" color="#2B398E" size="23" />
                              <span> {v}</span>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>

                    {loading && (
                      <div className={classes.loadingContent}>
                        <NewLoading />
                      </div>
                    )}
                  </Grid>
                )}
              </div>
            </Grid>
          </SimpleDialog>
        </>
      </Grid>
    </>
  );
}
